import $ from 'jquery';
import escape from 'lodash/escape';
import { finalize, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

import { moment } from '../lib/moment';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  AfterViewInit,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';

import { ServerApi } from '../services/server-api';
import { Session } from '../services/session';
import { fullName, extractResponseBody } from '../lib/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'base',
  styles: [''],
  template: '',
})
export class NotesModalComponent implements AfterViewInit, OnDestroy {
  @Input() public notes;
  @Input() public id;
  @Input() public isUpdateDisabled: boolean = false;
  public noteBody;
  public addingNote = false;
  @Output() public isModalOpen: EventEmitter<boolean> = new EventEmitter();
  protected endpoint: string;
  protected $modal;
  @ViewChild('heightOverflow', { static: false }) private heightOverflow;
  @ViewChild('notesArea', { static: false }) private notesArea;
  private el;

  constructor(
    el: ElementRef,
    @Inject(ServerApi) private api,
    @Inject(Session) public session,
    private cdr: ChangeDetectorRef,
  ) {
    this.el = el.nativeElement;
  }

  get isNoteEmpty() {
    return !this.noteBody.trim().length;
  }

  public ngAfterViewInit() {
    this.$modal = $(this.el.querySelector('.ui.modal'));
    this.$modal.modal();
  }

  public ngOnDestroy() {
    if (this.$modal.modal('is active')) this.$modal.modal('hide');
    this.$modal.modal('destroy');
    this.$modal.remove();
  }

  public setDeleteConfirmation(evt, note, flag) {
    note.isDeleteConfirmationVisible = flag;
    evt.preventDefault();
  }

  public deleteNote(note, loaderRef) {
    loaderRef.classList.remove('hide');
    const id = this.id;
    this.api.delete(`${this.endpoint}/${id}/notes/${note.id}`)
      .pipe(finalize(() => note.isDeleteConfirmationVisible = false))
      .subscribe(() => {
        const notes = this.notes;
        const index = notes.indexOf(note);
        notes.splice(index, 1);
        this.cdr.markForCheck();
        this._refreshPosition();
        loaderRef.classList.add('hide');
      },(err: HttpErrorResponse) => {
        loaderRef.classList.add('hide');
      });
  }

  public addNote(event = null) {
    if (this.isNoteEmpty) return false;
    const id = this.id;
    const params = new Map();
    this.addingNote = true;
    this.cdr.markForCheck();
    this.api
      .post(`${this.endpoint}/${id}/notes/`, { body: escape(this.noteBody) }, params)
      .pipe(
        map(extractResponseBody),
        map((data: any) => data.note),
        finalize(() => this.addingNote = false),
      )
      .subscribe(note => {
        this.notes.push({
          id: note.id,
          body: note.body,
          createdAt: moment(note.created_at),
          user: {
            id: note.user.id,
            name: fullName(note.user),
          },
        })
        ;

        this.noteBody = '';
        this.addingNote = false;
        this.cdr.markForCheck();
        this._refreshPosition(true);
      });
    if (event) event.preventDefault();
  }

  public show(): void {
    this.$modal.modal({
      onHide: () => {
        this.isModalOpen.emit(true);
      },
      onShow: () => {
        this.isModalOpen.emit(false);
      },
    }).modal('show');

    if (this.notes.length) {
      this.heightOverflow.overflowCheck();
    }
  }

  public trackByNoteId(index, note) {
    return note.id;
  }

  private _refreshPosition(isAddNote = null) {
    setTimeout(() => {
      this.$modal.modal('refresh');
      if (isAddNote) {
        const dimmer = $('.ui.modal.notes .notes-list');
        dimmer.animate({
          scrollTop: dimmer.prop('scrollHeight'),
        }, 800);
      }
    }, 0);
    this.notesArea.nativeElement.focus();
  }
}
